module.exports = __webpack_public_path__ + "static/media/Zangoose_gaussian2.37b59e76.png";